import {Card, CardContent, Chip, styled} from '@mui/material'
import useDanceItem from 'logic/Dances/useDanceItem'
import DanceItemControls from 'components/Page/DanceItem/DanceItemControls'
import DanceItemInfo from 'components/Page/DanceItem/DanceItemInfo'

const DanceListItem = ({
    dance,
    index,
    total,
    handleRemoveDance,
    handleMoveDance,
    choreographersLabelKey = 'danceCollections.choreographersLabel',
    showControls = true,
    moveUpLabel,
    moveDownLabel,
    removeLabel,
}) => {
    const {displayName, isFirst, isLast, onDanceClick} = useDanceItem(
        index,
        total,
        dance
    )

    const shouldShowControls =
        showControls && (handleMoveDance || handleRemoveDance)

    return (
        <Container>
            <DanceCard variant="outlined" onClick={onDanceClick}>
                <DanceContent>
                    <LeftGroup>
                        <NumberBadge
                            variant="outlined"
                            color="primary"
                            label={`#${index + 1}`}
                            size="small"
                        />
                        <DanceItemInfo
                            dance={dance}
                            displayName={displayName}
                            choreographersLabelKey={choreographersLabelKey}
                        />
                    </LeftGroup>
                    <Chip label={dance._id} size="small" variant="outlined" />
                </DanceContent>
            </DanceCard>
            {shouldShowControls && (
                <DanceItemControls
                    index={index}
                    isFirst={isFirst}
                    isLast={isLast}
                    handleMoveDance={handleMoveDance}
                    handleRemoveDance={handleRemoveDance}
                    showRemove={!!handleRemoveDance}
                    moveUpLabel={moveUpLabel}
                    moveDownLabel={moveDownLabel}
                    removeLabel={removeLabel}
                />
            )}
        </Container>
    )
}

export default DanceListItem

const Container = styled('div')`
    display: flex;
    align-items: center;
    gap: 12px;
`

const DanceCard = styled(Card)`
    flex-grow: 1;
`

const DanceContent = styled(CardContent)(({theme}) => ({
    padding: '12px 16px !important',
    display: 'flex',
    alignItems: 'start',
    justifyContent: 'space-between',
    gap: '16px',
    '&:last-child': {
        paddingBottom: '12px',
    },
    flexDirection: theme.breakpoints.down('sm') ? 'column' : 'row',
}))

const NumberBadge = styled(Chip)(({theme}) => ({
    fontWeight: 600,
    minWidth: 48,
    display: theme.breakpoints.down('sm') ? 'none' : 'block',
}))

const LeftGroup = styled('div')`
    display: flex;
    align-items: flex-start;
    gap: 12px;
    flex: 1;
`
